<template>
  <div class="main-container clear">
    <div ref="videoWrap" id="video-wrap" class="video-left f-left"></div>
    <div class="f-right chapters">
      <CourseChapter :course="course" :currentPeriod="period_id"></CourseChapter>
    </div>
  </div>
</template>
<script>
import CourseChapter from "../../components/CourseChapter.vue";
import Vue from "vue";

export default {
  name: "Video",
  components: {
    CourseChapter
  },
  data() {
    return {
      course_type: "",
      course_id: "",
      period_id: "",
      video_id: "",
      course: {},
      isPlay:false,
      currentTime:0,
    };
  },
  async created() {
    this.init();
    await this.play();
  },
  methods: {
    init() {
      this.course_id = this.$route.query.course_id;
      this.course_type = this.$route.query.course_type;
      this.period_id = this.$route.query.period_id.toString();
      this.video_id = this.$route.query.video_id;
      this.course = { id: this.course_id, course_type: this.course_type };
    },
    async play() {
      if (this.course_type == 5 || this.course_type == 8) {
        if (this.video_id == "") {
          return;
        }
        let data = await this.$http.get(
          "/api/app/getPlayToken/video_id=" +
            this.video_id +
            "/course_id=" +
            this.course_id
        );
       // 是否允许控制播放
      Vue.config.bjy_player = new window.BPlayer({
        container: document.getElementById("video-wrap"), // 设置播放器初始化的父容器
        token: data.token,
        memory: true, //记忆播放
        vid: data.video_id,
        currentTime: 0,
        loop: 3,
        enableDrag: true, // 是否允许拖拽进度条
        rateList:[0.5, 0.75, 1, 1.25, 1.5, 2], // 倍速列表
        user: {
          name: '', // 观看的学员用户名
          number: '', // 观看的学员number
        },
      });
      const eventTypes = {
        PLAY: "play", // 首次播放
        PLAYING: "playing", // 暂停后播放
        PAUSE: "pause", // 暂停
        SEEKING: "seeking", // 快进快退中
        WAITING: "waiting", // 加载中
        SEEKED: "seeked", // 快进快退结束
        ENDED: "ended", // 播放结束
        VOLUME_CHANGE: "volume_change", // 音量变化
        RATE_CHANGE: "rate_change", // 倍速变化
        ERROR: "error", // 播放出错
        TIMEUPDATE: "timeupdate", // 播放进度更新
        LOADEDMETADATA: "loadedmetadata", //
        QUALITY_CHANGE: "quality_change", // 切换清晰度
        ENDED_AD: "ended_ad", // 广告结束
        FULLSCREEN_CHANGE: "full_screen_change", // 全屏/退出全屏
      };
      // 监听首次播放事件
      Vue.config.bjy_player.on(eventTypes.PLAY, () => {
        this.isPlay = true;
      });
      Vue.config.bjy_player.on(eventTypes.PLAYING, () => {
        if (this.isPlay == false) {
          this.isPlay = true;
        }
      });
      // 暂停
      Vue.config.bjy_player.on(eventTypes.PAUSE, () => {
        this.isPlay = false;
      });
      // 进度条更新
      Vue.config.bjy_player.on(eventTypes.TIMEUPDATE, time => {
        this.currentTime = time;
      });
      // 结束
      Vue.config.bjy_player.on(eventTypes.ENDED, async () => {
        this.isPlay = false;
      });
      }
    }
  },
  watch: {
    $route: async function() {
      this.init();
      await this.play();
    }
  },
  destroyed() {
    window.$("#video-wrap").html("");
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.main-container {
  padding: 30px;
}
.video-left {
  width: 875px;
}
#videoplay {
  height: 500px;
  width: 100%;
  overflow: hidden;
}
.chapters {
  background-color: white;
  padding: 20px;
  width: 310px;
  box-sizing: border-box;
  max-height: 500px;
  overflow-y: auto;
  /deep/ .chapter-content.current .period-title {
    color: $primary-color;
  }
}
</style>
